import React from "react";
import { ColorRing } from "react-loader-spinner";

interface Props {
  type?: string;
  color?: string;
  height?: string;
  width?: string;
}

const Loader = ({ type, color, height, width }: Props) => {
  return (
    <ColorRing
      visible={true}
      height={height}
      width={width}
      ariaLabel="color-ring-loading"
      wrapperStyle={{}}
      wrapperClass="color-ring-wrapper"
      colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
    />
  );
};

export default Loader;
// import React from 'react';
// import Lottie from 'lottie-react';
// import Images from 'src/utils/images';


// interface Props {
//   height?: string;
//   width?: string;
// }

// const Loader = ({ height = '200px', width = '200px' }: Props) => {
//   return (
//     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//       <Lottie
//         animationData={Images.LOADER} 
//         loop={true}
//         autoplay={true}
//         style={{ height: height, width: width }}
//       />
//     </div>
//   );
// };

// export default Loader;
